import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Document = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 14 18">
      <g transform="matrix(1,0,0,1,-5.25,-3)">
        <path d="M14.29,3.335L15.079,4.125L15.078,4.125L18.416,7.465C18.63,7.68 18.751,7.972 18.75,8.276L18.748,8.951L18.748,18.75C18.748,19.98 17.761,20.98 16.536,21L7.499,21C6.269,21 5.27,20.013 5.25,18.787L5.25,5.25C5.25,4.02 6.237,3.02 7.463,3L13.482,3C13.785,3 14.076,3.12 14.29,3.335ZM13.125,4.125L7.5,4.125C6.888,4.125 6.39,4.613 6.375,5.221L6.375,18.75C6.375,19.362 6.863,19.86 7.471,19.875L16.5,19.875C17.111,19.875 17.609,19.387 17.624,18.779L17.624,9L15.374,9C14.144,9 13.145,8.013 13.125,6.787L13.125,4.125ZM15.842,16.875C16.153,16.875 16.405,17.127 16.405,17.438C16.405,17.748 16.153,18 15.842,18L8.156,18C7.846,18 7.593,17.748 7.593,17.438C7.593,17.127 7.845,16.875 8.156,16.875L15.842,16.875ZM15.842,14.625C16.153,14.625 16.405,14.877 16.405,15.188C16.405,15.498 16.153,15.75 15.842,15.75L8.156,15.75C7.846,15.75 7.593,15.498 7.593,15.188C7.593,14.877 7.845,14.625 8.156,14.625L15.842,14.625ZM15.842,12.375C16.153,12.375 16.405,12.627 16.405,12.938C16.405,13.248 16.153,13.5 15.842,13.5L8.156,13.5C7.846,13.5 7.593,13.248 7.593,12.938C7.593,12.627 7.845,12.375 8.156,12.375L15.842,12.375ZM15.842,10.125C16.153,10.125 16.405,10.377 16.405,10.688C16.405,10.998 16.153,11.25 15.842,11.25L8.156,11.25C7.846,11.25 7.593,10.998 7.593,10.688C7.593,10.377 7.845,10.125 8.156,10.125L15.842,10.125ZM14.25,4.873L14.25,6.75C14.25,7.362 14.738,7.86 15.346,7.875L17.25,7.875L14.249,4.873L14.25,4.873ZM11.437,6C11.747,6 11.999,6.252 11.999,6.563C11.999,6.873 11.747,7.125 11.437,7.125L8.062,7.125C7.752,7.125 7.5,6.873 7.5,6.563C7.5,6.252 7.752,6 8.062,6L11.437,6Z" />
      </g>
    </svg>
  );
};

Document.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Document;
